import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { useIsMobileVariant } from '@dhl-ui/components'
import { DashboardIcon, MoreHorizontalIcon, ParcelMIcon, RoutesIcon, TruckIcon } from '@dhl-ui/icons'
import { type PageMenuItem } from '@dhl-ui/page'

import { links } from '~/appLinks'
import { isFeatureEnabled } from '~/config'

export const useMenuItems = (): PageMenuItem[] => {
  const { t } = useTranslation()
  const location = useLocation()
  const isMobileVariant = useIsMobileVariant()
  const isDesktop = !isMobileVariant

  return [
    isFeatureEnabled('dashboard') && {
      key: 'dashboard',
      label: t('onboarding.dashboard'),
      icon: <DashboardIcon />,
      link: links.dashboardLink(),
      isActive: location.pathname.includes(links.dashboardLink()),
    },
    isFeatureEnabled('receive') && {
      key: 'receive',
      label: t('onboarding.bottomNavigation.receiveButton'),
      icon: <TruckIcon />,
      link: links.incomingPiecesLink(),
      isActive:
        location.pathname.includes(links.incomingPiecesLink()) || location.pathname.includes(links.trackTraceLinks()),
    },
    isFeatureEnabled('send') && {
      key: 'sent',
      label: t('onboarding.sent'),
      icon: <ParcelMIcon />,
      link: isDesktop ? links.c2cLink() : links.outgoingPiecesLink(),
      isActive: location.pathname.includes(links.outgoingPiecesLink()) || location.pathname.startsWith(links.c2cLink()),
    },
    isFeatureEnabled('locator') && {
      key: 'locator',
      label: t('onboarding.bottomNavigation.locatorButton'),
      icon: <RoutesIcon />,
      link: links.locatorLink(),
      isActive: location.pathname.includes(links.locatorLink()),
    },
    isFeatureEnabled('more') && {
      key: 'more',
      label: t('onboarding.bottomNavigation.moreButton'),
      icon: <MoreHorizontalIcon />,
      link: links.moreOverviewLink(),
      isActive: location.pathname.includes(links.moreOverviewLink()),
    },
  ].filter(Boolean) as PageMenuItem[]
}
